<template>
  <div class="mw-node-side-card">
    <header class="side-card-header py-2 px-3">
      <h3>{{ $t('mayday-web.return-button') }}</h3>
    </header>

    <main class="py-2">
      <div class="container">
        <div
          v-for="(item, idx) in previousItems"
          :key="item.id"
          class="row mb-2"
        >
          <div
            class="col-12 favorite-node"
            @click="openPreviousItem(item, idx)"
          >
            <div class="d-flex align-items-center favorite-node-content">
              <img
                :src="getIcon(item.type)"
                alt="not_found"
                class="small-icon mr-2"
              />
              {{ item.label }}
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'NodeSideCard',
  computed: {
    ...mapState('webKnowledgeModule', ['previousItems']),
  },
  methods: {
    getIcon(type) {
      switch (type) {
        case 'Article':
          return require('@/assets/article_icon.svg');
        case 'Diagnostic':
          return require('@/assets/diag_icon.svg');
        case 'Step':
          return require('@/assets/diag_icon.svg');
        case 'keyStep':
          return require('@/assets/diag_icon.svg');
        default:
          return require('@/assets/article_icon.svg');
      }
    },
    openPreviousItem(item, idx) {
      console.log(item, idx);
      this.$router.push({
        path:
          item.type === 'Step'
            ? `/web/content/${item.ancestorsContent[0].id}/step/${item.id}`
            : `/web/content/${item.id}`,
      });
      this.updatePreviousItems(this.previousItems.slice(0, idx));
    },
    ...mapActions('webKnowledgeModule', ['updatePreviousItems']),
  },
  watch: {
    $route(to) {
      const { contentId } = to.params;
      const routeIsPreviousItem = this.previousItems
        .map((item) => item.id)
        .includes(contentId);
      if (!contentId || routeIsPreviousItem) this.updatePreviousItems([]);
    },
  },
};
</script>

<style lang="scss" scoped>
h3 {
  margin: 0;
}
h2 {
  margin: 0;
}
.mw-node-side-card {
  width: 100%;
  background-color: white;
  border-radius: 4px;
  -webkit-box-shadow: 0px 10px 30px $shadow-4-mayday;
  -moz-box-shadow: 0px 10px 30px $shadow-4-mayday;
  box-shadow: 0px 10px 30px $shadow-4-mayday;
}
.side-card-header {
  border-bottom: 0.5px solid $grey-3-mayday;
}
.small-icon {
  width: 20px;
  height: 20px;
}
.favorite-node {
  cursor: pointer;
  &:hover {
    color: $blue-mayday;
  }
  .favorite-node-content {
    font-size: 14px;
  }
}
</style>
